
<div [class.content]="wrapContent">
    <div [class.center]="wrapContent">
        <ng-content></ng-content>
    </div>
</div>
